import statusTypes from "../../status-types";
import sourceTypes, { filterSourceTypes } from "../../source-types";
import propertyTypes from "../../property-types";
import propertyCategories from "../../property-categories";
import propertySubCategories from "../../property-sub-categories";    
import transactionTypes from "../../transaction-types";
import leaseTypes from "../../lease-types";
import markets from "../../markets";
import buyerMarkets from "../../buyer-markets";
import singleTenantSubcategories from "../../single-tenant-subcategories";
import multiTenantSubcategories from "../../multi-tenant-subcategories";
import singleMultiTenantIndustrialSubcategories from "../../single-multi-tenant-industrial-subcategories";
import singleTenantOffice from "../../single-tenant-office-subcategories.js";
import multiTenantOffice from "../../multi-tenant-office-subcategories.js";
import unitedStates from "united-states";
import profiles from "../../profiles";
import buyerStatus from "../../buyer-status";
import sellerStatus from "../../seller-status";
import pipelines from "../../pipelines";
import checkboxTypes from '../../checkbox-types';
import statusTypesFinancing from "../../status-types-financing";
import loanTypes from "../../loan-types";
import lenderLoanTypes from "../../lender-loan-types";
import filters from "../../filters";
import teamMembers from "../../hsc-team-members";
import loanQuotesAmortization from "../../loanquotes-amortization";
import loanQuotesApproved from "../../loanquotes-approved";
import { getSuperUsers } from "../../super-users";
import estimatedPrice from "../../estimated-price";
import referralType from "../../referral-type"
import confirmType from "../../confirm-type";
import roles from "../../roles";
import titleCompanies from "../../title-companies.js";
import psaModifications from "../../psa-modifications.js";
import { COUNTRIES } from "../../utils";

const superUsers = getSuperUsers();
export const getOptionsType = (optionsType, source = null) => {
    switch (optionsType) {
        case 'status':
            return source && source === 'SUMMIT' ? statusTypes.filter(status => status.code === 'Proposal' || status.code === 'Property Info') : statusTypes;
        case 'source':
            return sourceTypes;
        case 'filter-source':
            return filterSourceTypes;
        case 'type':
            return propertyTypes;
        case 'category':
            return propertyCategories;
        case 'subcategory':
            return propertySubCategories;
        case 'transaction':
            return transactionTypes;
        case 'lease':
            return leaseTypes;
        case 'market':
            return markets;
        case 'buyer-market':
            return buyerMarkets;
        case 'subcategorySTNL':
            return singleTenantSubcategories;
        case 'subcategoryMT':
            return multiTenantSubcategories;
        case 'subcategoryIndustrialSTNLMT':
            return singleMultiTenantIndustrialSubcategories;
        case 'singleTenantOffice':
            return singleTenantOffice;
        case 'multiTenantOffice':
            return multiTenantOffice;
        case 'states':
            return unitedStates.filter(el => !el.isTerritory);
        case 'superUsers':
            return superUsers;
        case 'profiles':
            return profiles;
        case 'buyerStatus':
            return buyerStatus;
        case 'pipeline':
            return pipelines;
        case 'checkbox':
            return checkboxTypes;
        case 'status-financing':
            return statusTypesFinancing;
        case 'loan':
            return loanTypes;
        case 'lenderLoanType':
            return lenderLoanTypes;
        case 'filters':
            return filters;
        case 'sellerStatus':
            return sellerStatus;
        case 'team-members':
            return teamMembers;
        case 'loanquotes-amortization':
            return loanQuotesAmortization;
        case 'loanquotes-approved':
            return loanQuotesApproved;
        case 'estimatedPrice':
            return estimatedPrice;
        case 'referralType':
            return referralType;
        case 'confirmType':
            return confirmType;
        case 'roles':
            return roles;
        case 'psa-modifications':
            return psaModifications;
        case 'title-companies':
            return titleCompanies;
        case 'countries':
            return COUNTRIES;
            
    }
    return null;
};